<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="date"
    transition="scale-transition"
    offset-y
    min-width="auto"
    class="mt-0 pt-0"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :disabled="disabled"
        v-model="dateFormatted"
        class="py-0"
        outlined dense rounded readonly
        :label="label"
        :placeholder="placeholder"
        :clearable="clearable"
        :hide-details="hideDetails"
        :height="20"
        v-bind="attrs"
        v-on="on"
        v-mask="'##.##.####'"
        :error-messages="errorMessage"
        @change="setDate"
        @click:clear="clear"
        @blur="$emit('blur')"
      />
    </template>
    <v-date-picker
      v-model="date"
      locale="ru-RU"
      color="green primary"
      format="DD.MM.YYYY"
      first-day-of-week=1
      @input="save(date)"
      no-title scrollable
    >
    </v-date-picker>
  </v-menu>
</template>

<script>

export default {
  name: 'UIDatePicker',

  props: {
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    value: String,
    placeholder: {
      type: String,
      default: 'Выберите значение'
    },
    errorMessage: {
      type: Array
    }
  },

  components: {
  },

  mounted() {
    if (!this.date) this.date = this.value
  },

  data: () => {
    return {
      menu: false,
      date: null,
      dateFormatted: null,
      clicks: 0,
      timer: null,
      delay: 200
    }
  },

  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },

    clear() {
      this.date = null
      this.save(null)
    },

    save(date) {
      this.$refs.menu.save(date)
      this.$emit('input',this.date)
    },

    setDate(newDate) {
      const date = newDate ? newDate.split('.').reverse().join('-') : ''
      this.$refs.menu.save(date)
      this.$emit('input', date)
    },
  },

  watch: {
    value(v) {
      this.date = v
    },

    date(v) {
      this.dateFormatted = this.formatDate(v)
    }
  }
}
</script>

<style scoped>
</style>